// extracted by mini-css-extract-plugin
export default {"HeaderWrapper":"VOXXvxTqn1Z1Ls+saNq3qw=="};